export default {
  install: (app) => {
    const components = require.context('./components/dp', false, /[A-Za-z0-9\s]+\.vue$/i);
    components.keys().forEach(fileName => {
      app.component(components(fileName).default.name, components(fileName).default);
    });
  }
}
